import { AfterContentInit, Component, Inject, OnDestroy, OnInit } from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import { SpinnerService } from '../spinner/spinner.service'
import { PDFDocumentProxy }  from 'ng2-pdf-viewer';


@Component({
  selector: 'app-preview',
  templateUrl: './preview.component.html',
  styleUrls: ['./preview.component.scss']
})

export class PreviewComponent implements AfterContentInit{
  name = 'Angular';
  pdfSrc: string = '';
  pdfName: string = '';
  pdfDescarga: PDFDocumentProxy;
  constructor(
    dialog: MatDialogRef<PreviewComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private spinnerService: SpinnerService
  ){
  }

  spinnerRef:any;

  ngOnInit(){
    this.pdfSrc =  this.data.file;
    this.pdfName = this.data.name;
    this.spinnerRef = this.spinnerService.start();
  }

  contentLoaded() {
    this.spinnerRef = this.spinnerService.start();
    console.log("ada")
  }

  callBackFn(pdf: PDFDocumentProxy) {
    this.pdfDescarga = pdf;
    this.spinnerService.stop(this.spinnerRef);
 }

  ngAfterContentInit(): void {
   //this.spinnerService.stop(this.spinnerRef);
  }

  download() {
    this.pdfDescarga.getData().then((u8) => {
        let blob = new Blob([u8.buffer], {
            type: 'application/pdf'
        });
    
            // Chrome, Safari, Firefox, Opera
            let url = URL.createObjectURL(blob);
            this.openLink(url);
            // Remove the link when done
            setTimeout(function () {
                window.URL.revokeObjectURL(url);
            }, 5000);
        
    });
}

  private openLink(url: string) {
      let a = document.createElement('a');
      // Firefox requires the link to be in the body
      document.body.appendChild(a);
      a.style.display = 'none';
      a.href = url;
      a.download = this.pdfName;
      a.click();
      // Remove the link when done
      document.body.removeChild(a);
  }

  onError(error: any) {
    this.spinnerService.stop(this.spinnerRef);
  }
}
